<template>
    <div class="footerr">
        <div class="footerCont">
            <div class="footerCon">
                <div class="footer-left">
                    <div class="leftItem">
                        <span>客服微信</span>
                        <img src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/kfwx.png">
                    </div>
                    <div class="leftItem">
                        <span>客服QQ</span>
                        <img src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/kfqq.png">
                    </div>
                </div>
                <div class="footer-right">
                    <div class="footer-right-left">
                        <span>国内电商代运营服务</span>
                        <span v-for="item in listData1" :key="item.title" @click="changeRoute(item.href)">
                            {{ item.title }}
                        </span>
                    </div>
                    <div class="footer-right-left">
                        <span>跨境电商代运营服务</span>
                        <span v-for="item in listData3" :key="item.title" @click="changeRoute(item.href)">
                            {{ item.title }}
                        </span>
                    </div>
                    <div class="footer-right-right">
                        <span>国内电商推广工具</span>
                        <span v-for="item in listData2" :key="item.title" @click="changeRoute(item.href)">
                            {{ item.title }}
                        </span>
                    </div>
                    <div class="footer-right-right">
                        <span>跨境电商推广工具</span>
                        <span v-for="item in listData4" :key="item.title" @click="changeRoute(item.href)">
                            {{ item.title }}
                        </span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    name: 'footerr',
    data() {
        return {
            listData1: [
                { title: '万相台无界托管', href: 'https://fuwu.taobao.com/ser/detail.htm?service_code=ts-1796606&spm=a21lp.26139860.0.0.3c0341064nSfTX&code=ts-1796606' },
                { title: '京东快车/京准通托管', href: '/jdReplace' },
                { title: '拼多多直通车托管', href: '/pddReplace' },
                { title: '淘宝/京东/拼多多全店代运营', href: '/wholeShop' },
                { title: '美工服务', href: '/designServe' },
                { title: '抖店推广托管', },
            ],
            listData3: [
                { title: '虾皮代运营', href: 'https://service.shopeecb.cn/shop-management/1004/product-49' },
                { title: '阿里国际站代运营', href: '/cbeCommerce' },
                { title: '亚马逊代运营', href: '/cbeCommerce' },
                { title: 'Lazada代运营', href: 'https://marketplace.lazada.com.my/web/detail.html?articleCode=FW_GOODS-1000014864' },
            ],
            listData2: [
                { title: '无界直通车推广工具-省油宝', href: "https://fuwu.taobao.com/ser/detail.htm?service_code=ts-1796606" },
                // { title: '引力魔方自动优化软件', href: '/superMF' },
                { title: '无界一体化优化软件-省油智投', href: 'https://fuwu.taobao.com/ser/detail.htm?service_code=ts-1797607&spm=a21lp.26139860.0.0.3c0341064nSfTX&code=ts-1797607' },
                { title: '京东快车推广工具-省油快车', href: 'https://fw.jd.com/main/detail/FW_GOODS-385001?p=fw&t=pcsearch' },
            ],
            listData4: [
                { title: 'LAZADA推广工具-AIMAX省油宝', href: 'https://marketplace.lazada.com.my/web/detail.html?articleCode=FW_GOODS-1000015005' },
            ]
        }
    },
    methods: {
        changeRoute(value) {

            if (value) {
                if (value.includes('http')) {
                    window.open(value)
                } else {
                    this.$router.push(value)
                }
            } else {
                console.log('a')
                this.$router.push('/')
                setTimeout(() => {
                    document.documentElement.scrollTop = 900
                }, 0);

            }
        }
    }
}
</script>
<style lang="less" scoped>
.footerr {
    width: 100%;
    display: flex;
    justify-content: center;

    .footerCont {
        width: 1920px;
        min-width: 1200px;
        padding: 53px;
        background-color: #2D334B;
        display: flex;
        justify-content: center;

        .footerCon {
            width: 1200px;
            display: flex;
            justify-content: center;

            .footer-left {
                display: flex;
                flex: 1.8;
                justify-content: flex-start;

                .leftItem {
                    display: flex;
                    flex-direction: column;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    font-weight: bold;
                    color: #FFFFFF;

                    img {
                        height: 120px;
                        width: 120px;
                    }

                    span {
                        padding: 14px 0 16px 0;
                        cursor: pointer;
                    }
                }

                .leftItem:last-child {
                    margin-left: 30px;
                }
            }

            .footer-right {
                display: flex;
                flex: 5;
                border-left: 1px solid #4C5473;
                // padding-left: 80px;

                &-left,
                &-right {
                    display: flex;
                    flex-direction: column;
                    margin-left: 30px;

                    span {
                        color: rgba(255, 255, 255, 0.6);
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        font-weight: 400;
                        text-align: left;
                        padding: 10px 0 0px;
                        cursor: pointer;
                    }

                    span:first-child {
                        color: #fff;
                        font-weight: bold;
                        padding-bottom: 15px;
                    }

                    span:last-child {
                        padding-bottom: 15px;
                    }
                }
            }
        }
    }

}
</style>